import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/home-soft-banner")({
  component: lazyRouteComponent(() => import("./-pages/admin.home-soft-banner")),
  head: () => ({
    meta: [
      { title: "بلوك ٥ — إدارة" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
